import { useTextDomainContext } from "@/app/providers";
import React, { useContext } from "react";
import { ChangePasswordForm, ModalBox } from "@/components";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { bool, func } from "prop-types";

type ChangePasswordModalProps = {
  open: boolean;
  handleClose: () => void;
};

export const ChangePasswordModal = (props: ChangePasswordModalProps) => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  // const partnerName = getPartnerName();

  return (
    <ModalBox open={props.open} handleClose={props.handleClose}>
      <Box
        sx={{
          backgroundColor: (theme) => theme.palette.grey[50],
          p: 4,
        }}
      >
        <Box
          sx={{
            textAlign: "center",
            pb: 3,
          }}
        >
          <Typography variant="h4">{gettext("Change password")}</Typography>
        </Box>
        <Box>
          <ChangePasswordForm handleClose={props.handleClose} />
        </Box>
      </Box>
    </ModalBox>
  );
};

ChangePasswordModal.propTypes = {
  open: bool.isRequired,
  handleClose: func.isRequired,
};
